"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clampWidth = exports.getLineStyle = exports.getStepIndicator = exports.getStepState = exports.LINE_WIDTHS = exports.LINE_STYLE_LABEL = exports.LINE_STYLES = exports.STEP_INDICATOR_LABEL = exports.STEP_INDICATORS = exports.STEP_STATE_LABEL = exports.STEP_STATES = exports.HALO_OFFSET = exports.ITEM_GAP = exports.INDICATOR_SIZE = exports.DEF_LINE_WIDTH = exports.DEF_HALO_WIDTH = exports.DEF_RING_WIDTH = exports.DEF_LINE = exports.DEF_HALO = exports.DEF_RING = exports.DEF_INDICATOR = exports.DEF_STATE = void 0;
exports.DEF_STATE = 'active';
exports.DEF_INDICATOR = 'number';
exports.DEF_RING = 'solid';
exports.DEF_HALO = 'none';
exports.DEF_LINE = 'solid';
exports.DEF_RING_WIDTH = 1;
exports.DEF_HALO_WIDTH = 1;
exports.DEF_LINE_WIDTH = 1;
exports.INDICATOR_SIZE = 28;
exports.ITEM_GAP = 14;
exports.HALO_OFFSET = 4;
exports.STEP_STATES = ['active', 'pending', 'done', 'warning', 'error', 'optional'];
exports.STEP_STATE_LABEL = {
    active: 'Active',
    pending: 'Pending',
    done: 'Done',
    warning: 'Warning',
    error: 'Error',
    optional: 'Optional',
};
exports.STEP_INDICATORS = ['number', 'symbol', 'chars'];
exports.STEP_INDICATOR_LABEL = {
    number: 'Number',
    symbol: 'Symbol',
    chars: 'Chars',
};
exports.LINE_STYLES = ['none', 'solid', 'dashed', 'dotted', 'squiggly'];
exports.LINE_STYLE_LABEL = {
    none: 'None',
    solid: 'Solid',
    dashed: 'Dashed',
    dotted: 'Dotted',
    squiggly: 'Squiggly',
};
exports.LINE_WIDTHS = [0, 1, 2, 3, 4, 5, 6];
const isStepState = (v) => v === 'active' || v === 'pending' || v === 'done' || v === 'warning' || v === 'error' || v === 'optional';
const isStepIndicator = (v) => v === 'number' || v === 'symbol' || v === 'chars';
const isLineStyle = (v) => v === 'none' || v === 'solid' || v === 'dashed' || v === 'dotted' || v === 'squiggly';
const getStepState = (v) => (isStepState(v) ? v : exports.DEF_STATE);
exports.getStepState = getStepState;
const getStepIndicator = (v) => (isStepIndicator(v) ? v : exports.DEF_INDICATOR);
exports.getStepIndicator = getStepIndicator;
const getLineStyle = (v, fallback) => (isLineStyle(v) ? v : fallback);
exports.getLineStyle = getLineStyle;
const clampWidth = (v) => {
    const n = Math.round(Number(v) || 0);
    if (n <= 0)
        return 0;
    if (n >= 6)
        return 6;
    return n;
};
exports.clampWidth = clampWidth;
